const styles = {
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    width: '100%',
  },
  icons: {
    // Your existing icon styles here
  },
  pageTitle: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 500,
  },
  divider: {
    margin: '8px 0 0 0',
    borderBottom: '1px solid #E0E0E0',
    width: '100%',
  },
}

export default styles
